<template>
  <div
    class="wrapper"
    v-bind:class="[
      { collapsedmenu: toggleDrawer },
      { collapseaside: toggleAsidebar },
    ]"
    v-if="oidcUser"
  >
    <header-bar @toggleChange="toggleChange" />
    <side-bar v-if="!isToggle" />
    <div class="content-wrapper">
      <slot />
    </div>
    <aside-bar />
    <div
      @click="toggleDrawerClick"
      v-if="!toggleDrawer && mobile"
      class="menu-layer"
    ></div>
  </div>
</template>

<script>
import sidebar from "./Sidebar";
import headerbar from "./HeaderBar";
import asidebar from "./Aside";

import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("oidcStore");
export default {
  name: "DefaultLayout",
  components: {
    "side-bar": sidebar,
    "header-bar": headerbar,
    "aside-bar": asidebar,
  },
  data: function () {
    return {
      toggleSidebar: false,
      toggleAsidebar: false,
      mobile: window.innerWidth <= 1024,
      isToggle: false,
    };
  },
  created() {
    addEventListener("resize", () => {
      this.mobile = innerWidth <= 1024;
    });
  },
  methods: {
    toggleDrawerClick: function () {
      this.$store.commit("toggleDrawerClick");
    },
    toggleChange(e) {
      this.isToggle = e.isToggle;
    },
  },
  mounted() {
    this.$root.$on("flyoutAsidebar", () => {
      this.toggleAsidebar = !this.toggleAsidebar;
    });
    let ActiveCheck = JSON.parse(localStorage.getItem("isActive"));
    // console.log(" this.isToggle1", this.isToggle);
    this.isToggle = ActiveCheck == null ? false : ActiveCheck;
    // console.log("22222",this.$store.state.showNavigationMenu)
  },
  computed: {
    ...mapGetters(["oidcUser"]),
    toggleDrawer() {
      return this.$store.getters.isDrawer;
    },
    showNavigation() {
      return this.$store.state.showNavigationMenu;
    },
  },
};
</script>
